<template>
<div>

    <v-dialog v-model="$store.state.main.cardOpened" width="800px">
        <v-card>
            <v-card-title class="grey lighten-4 py-4 title">
                Нове замовлення
            </v-card-title>
            <v-container grid-list-sm pa-4 fluid>
                <v-layout row wrap flex-wrap>
                    <h2 class="title grey--text my-1">Ремонт</h2>
                    <v-flex xs12>
                        <v-switch v-model="isTyphoonProduct" color="purple" @change="" label="Товар Тайфун"></v-switch>
                        <v-autocomplete label="Товар" v-if="isTyphoonProduct" @change="setProductName" v-model="selectProduct" data-vv-name="selectProduct" data-vv-as="Товар" v-validate="'required'" :error-messages="errors.collect('selectCity')" :loading="loadingProduct" :items="itemsProduct" :search-input.sync="searchProduct" cache-items flat hide-no-data hide-details prepend-icon="shopping_basket"></v-autocomplete>
                        <v-text-field v-show="!isTyphoonProduct" label="Назва товару" v-model="productName" data-vv-name="productName" data-vv-as="Назва товару" prepend-icon="shopping_basket" v-validate="'required'" :error-messages="errors.collect('productName')"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field label="Серійний номер" v-model="serialCode" data-vv-name="serialCode" data-vv-as="Серійний номер" v-validate="'required'" :error-messages="errors.collect('serialCode')" prepend-icon="code"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field label="Серійний номер 2" v-model="serialCode2" prepend-icon="code"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field label="Серійний номер 3" v-model="serialCode3" prepend-icon="code"></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12>
                        <v-text-field prepend-icon="code" label="Номер гарантійного талону" v-model="garantyCode" data-vv-name="garantyCode" data-vv-as="Номер гарантійного талону" v-validate="'required'" :error-messages="errors.collect('garantyCode')"></v-text-field>
                    </v-flex>
                    <v-flex xs12> -->

                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :nudge-right="40" :return-value.sync="date" lazy transition="scale-transition" offset-y full-width min-width="290px">
                        <v-text-field slot="activator" v-model="date" label="Дата продажу" prepend-icon="event" readonly data-vv-as="Дата" v-validate="'required'" data-vv-name="date" :error-messages="errors.collect('date')"></v-text-field>
                        <v-date-picker v-model="date" no-title scrollable locale="uk">
                            <v-spacer></v-spacer>
                            <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                            <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>

                    </v-flex>
                    <v-flex xs12>
                        <v-textarea prepend-icon="date" label="Опис дефекту" v-model="defect" data-vv-name="defect" data-vv-as="Опис дефекту" v-validate="'required'" :error-messages="errors.collect('defect')"></v-textarea>
                    </v-flex>
                    <h2 class="title grey--text my-1">Контактні дані клієнта</h2>
                    <v-flex xs12>
                        <v-layout>
                            <v-text-field field prepend-icon="perm_identity" label="ПІБ Клієнта" v-model="clientName" data-vv-name="clientName" data-vv-as="ПІБ Клієнта" v-validate="'required'" :error-messages="errors.collect('clientName')"></v-text-field>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field type="tel" prepend-icon="phone" label="Телефон клієнта" placeholder="(000) 000 - 0000" mask="phone" v-model="clientPhone" data-vv-name="clientPhone" data-vv-as="Телефон клієнта" v-validate="'required|length:10'" :error-messages="errors.collect('clientPhone')"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-autocomplete label="Місто" v-model="selectCity" data-vv-name="selectCity" data-vv-as="Місто" v-validate="'required'" :error-messages="errors.collect('selectCity')" :loading="loadingCity" :items="itemsCity" :search-input.sync="searchCity" cache-items flat hide-no-data hide-details prepend-icon="business"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field prepend-icon="mail" label="Адреса клієнта" v-model="clientAddress" data-vv-name="clientAddress" data-vv-as="Адреса клієнта" v-validate="'required'" :error-messages="errors.collect('clientAddress')"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-select prepend-icon="date" label="Тип послуги" :items="itemsServiceStatus" v-model="serviceStatus" data-vv-name="serviceStatus" data-vv-as="Тип послуги" v-validate="'required'" :error-messages="errors.collect('serviceStatus')"></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-select prepend-icon="date" :items="itemsRepairTypes" label="Тип ремонту" v-model="repairType" data-vv-name="repairType" data-vv-as="Тип ремонту" v-validate="'required'" :error-messages="errors.collect('repairType')"></v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea prepend-icon="notes" v-model="notes" label="Нотатки"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-card-actions>

                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="cardClose()">Скасувати</v-btn>
                <v-btn flat @click="submit" :disabled="submitDisable">Зберегти</v-btn>
            </v-card-actions>

        </v-card>

    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
        <v-icon color="white">{{snackbarIcon}}</v-icon> {{snackbarText}}
    </v-snackbar>
</div>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {},
    props: {},
    data: function () {
        return {
            error: [],
            submitDisable: false,
            dictionary: {
                attributes: {
                    //serialCode: 'Серійний номер'
                },
                custom: {
                    clientPhone: {
                        length: 'Вкажіть коректний номер телефону'
                    },
                }
            },
            garantyCode: '',
            serialCode: null,
            serialCode2: null,
            serialCode3: null,
            repairType: null,
            clientAddress: null,
            clientName: null,
            clientPhone: '',
            defect: '',

            picker: new Date().toISOString().substr(0, 10),
            date: '',
            menu: false,

            loadingCity: false,
            itemsCity: [],
            searchCity: null,
            selectCity: null,

            isTyphoonProduct: true,
            productName: '',

            loadingProduct: false,
            itemsProduct: [],
            searchProduct: null,
            selectProduct: null,

            itemsRepairTypes: [],

            itemsServiceStatus: [],
            serviceStatus: null,
            notes: '',
            snackbar: false,
            snackbarText: '',
            snackbarColor: '',
            snackbarIcon: '',
            timeout: 6000

        }
    },

    methods: {
        cardClose() {
            this.$store.commit('openCloseCard', false)
            this.$validator.reset()
            this.$root.$emit('reloadRepairTable');
        },
        setProductName() {
            let result = this.itemsProduct.filter(obj => {
                return obj.value === this.selectProduct
            })
            this.productName = result[0].text
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (result) {
                    this.submitDisable = true
                    HTTP.post('/repair_card/new_card', {
                            garantyCode: this.garantyCode,
                            serialCode: this.serialCode,
                            serialCode2: this.serialCode2,
                            serialCode3: this.serialCode3,
                            repairType: this.repairType,
                            clientAddress: this.clientAddress,
                            clientName: this.clientName,
                            clientPhone: this.clientPhone,
                            defect: this.defect,
                            saleDate: this.date,
                            city: this.selectCity,
                            product: this.selectProduct,
                            serviceStatus: this.serviceStatus,
                            notes: this.notes,
                            isTyphoonProduct: this.isTyphoonProduct,
                            productName: this.productName

                        }).then(response => {
                            if (response.status == 200 && response.data && response.data.status == 'ok') {
                                this.cardClose()
                                //reset $data
                                Object.assign(this.$data, this.$options.data.call(this))

                                this.snackbarText = 'Успiшно завантажено'
                                this.snackbarColor = 'info'
                                this.snackbarIcon = 'done_outline'

                            } else {
                                this.snackbarText = 'Помилка ' + response.data.error
                                this.snackbarColor = 'error'
                                this.snackbarIcon = 'error'
                            }

                        }).catch(e => {
                            this.snackbarText = 'Помилка: 500'
                            this.snackbarColor = 'error'
                            this.snackbarIcon = 'error'
                        })
                        .finally(
                            () => {
                                this.submitDisable = false
                                this.snackbar = true
                            }
                        )
                }
            })
        },
        querySelectionsCity(v) {
            if (this.searchCity.length > 2) {

                this.loadingCity = true
                HTTP.get(`/layout/search_city/?q=` + this.searchCity)
                    .then(response => {
                        if (response.status == 200 && response.data && response.data.data) {
                            this.itemsCity = response.data.data
                        }
                    })
                    .catch(e => {
                        this.error.push(e)
                    })
                    .finally(
                        () => {
                            this.loadingCity = false
                        }
                    )
            }

        },
        querySelectionsProduct(v) {
            if (this.searchProduct.length > 2) {
                this.loadingProduct = true
                HTTP.get(`/layout/search_product/?q=` + this.searchProduct)
                    .then(response => {
                        if (response.status == 200 && response.data && response.data.data) {
                            this.itemsProduct = response.data.data
                        }
                    })
                    .catch(e => {
                        this.error.push(e)
                    })
                    .finally(
                        () => {
                            this.loadingProduct = false
                        }
                    )
            }
        }

    },
    watch: {
        searchCity(val) {
            val && val !== this.select && this.querySelectionsCity(val)
        },
        searchProduct(val) {
            val && val !== this.select && this.querySelectionsProduct(val)
        }

    },
    mounted() {
        this.$validator.localize('uk', this.dictionary)
    },
    created() {
        HTTP.get('/layout/ref_repair_type')
            .then(response => {
                if (response.status == 200 && response.data && response.data.data) {
                    this.itemsRepairTypes = response.data.data
                }
            })
            .catch(e => {
                this.error.push(e)
            })

        HTTP.get('/layout/ref_service_status')
            .then(response => {
                if (response.status == 200 && response.data && response.data.data) {
                    this.itemsServiceStatus = response.data.data
                }
            })
            .catch(e => {
                this.error.push(e)
            })

    }
}
</script>
